import { render, staticRenderFns } from "./BrandListAddModal.vue?vue&type=template&id=119cb910&scoped=true&"
import script from "./BrandListAddModal.vue?vue&type=script&lang=js&"
export * from "./BrandListAddModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandListAddModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandListAddModal.vue?vue&type=style&index=1&id=119cb910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119cb910",
  null
  
)

export default component.exports